import React from 'react';
import { PropTypes } from 'prop-types';
import { Col, Row } from 'reactstrap';
import QuestionBool from './questionBool';
import QuestionOptions from './questionOptions';

const QuestionsList = ({ group, current, canEditPage }) => (
  <div>
    <h5 className="questionnaire__title">{group.name}</h5>
    <p className="questionnaire__description">{group.description}</p>
    <div className="questionnaire__rule">{group.scoringRule}</div>
    <Row>
      {group.questions.map((question) => (
        <Col
          xl={current === 3 || current === 5 || current === 6 ? 6 : 12}
          className="questionnaire__question"
          key={question.guid}
        >
          {question.questionType === 1 ? (
            <QuestionOptions
              current={current}
              question={question}
              canEditPage={canEditPage}
            />
          ) : (
            <QuestionBool
              current={current}
              question={question}
              canEditPage={canEditPage}
            />
          )}
        </Col>
      ))}
    </Row>
  </div>
);

QuestionsList.propTypes = {
  group: PropTypes.object.isRequired,
  current: PropTypes.number.isRequired,
  canEditPage: PropTypes.bool,
};

export default QuestionsList;
